import { Mediator } from '../mediator';
import { LoginState } from '../state';

export const authActions = {
    logout: new Mediator<void, void>(),
    getLoginState: new Mediator<void, LoginState>(),
};
